import { CountDown as AntdCountDown } from "@empglabs/backoffice-ui-kit"

const CountDown = props => {
  return <AntdCountDown {...props} />
}

export default CountDown
